import { takeLatest, fork, put, all, call } from "redux-saga/effects";

import {
  GET_MALWARE_SCAN_LOGS,
  CLEAR_ALL_MALWARE_SCAN_LOGS_MESSAGES,
} from "./actionTypes";

import {
  getMalwareScanLogsSuccessful,
  getMalwareScanLogsFailed,
  clearAllMalwareScanLogsMessagesSuccessful,
} from "./actions";

import {
  malwarelogs as malwarelogsApi
} from "../../helpers/auth_helper";


const transformData = (apiData) => {
  console.log("apiData", apiData);
  const transformedData = [];

  apiData.forEach( item => {
    const key = item.key;
    const obj = { key };

    item.content.forEach(contentItem => {
      const contentKey = contentItem[0];
      const contentValue = contentItem[1];
      obj[contentKey] = contentValue;
    });
    transformedData.push(obj);
  });

  return transformedData;
}


function* getMalwareScanLogs( {payload} ) {
  try {
    const response = yield call(malwarelogsApi);
    console.log("getMalwareScanLogs Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      yield put(getMalwareScanLogsSuccessful(transformData(Object.values(response))));
    }
    else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(getMalwareScanLogsFailed({ message: message }));
    }
  } catch (error) {
    console.log("addOrgUserApi Error: ", error);
    if(error.response){
      yield put(getMalwareScanLogsFailed({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(getMalwareScanLogsFailed({message: "No response is received"}))
    } else{
      yield put(getMalwareScanLogsFailed({message: error?.message}));
    }
  }
}

export function* clearAllMalwareScanLogsMessages() {
  console.log("clearAllMalwareScanLogsMessages Saga: clear all messages");
  yield put(clearAllMalwareScanLogsMessagesSuccessful());
}

function* watchMalwareScan() {
  yield takeLatest(GET_MALWARE_SCAN_LOGS, getMalwareScanLogs);
  yield takeLatest(CLEAR_ALL_MALWARE_SCAN_LOGS_MESSAGES, clearAllMalwareScanLogsMessages);
}

function* malwareScanSaga() {
  yield all([fork(watchMalwareScan)]);
}

export default malwareScanSaga;